var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['color-swatch mr-3 mb-3', { active: _vm.color.id === _vm.currentColor.id }],style:(`background-color: #${_vm.color.hexcode}`),attrs:{"title":_vm.color.color_name}})
}
var staticRenderFns = []

export { render, staticRenderFns }